/* import __COLOCATED_TEMPLATE__ from './cell.hbs'; */
/**
Cell component yielded by `sq-table`, not intended for standalone use.

### Parameters
@param {Boolean} [isFixedLeft=false] - Fixes the column to the left, allowing other cells to horizonally scroll beneath it. Only works for cells in the first column.
```
*/

import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'td',
  attributeBindings: ['colspan', 'rowspan', 'scope'],
  classNames: ['sq-table__cell'],
  classNameBindings: ['isFixedLeft:sq-table__cell--is-fixed-left'],
  isFixedLeft: false
});